import { RouterProvider } from '@tanstack/react-router';
import { useMemo } from 'react';
import { createAppRouter } from '@/app/router/router';
import { ErrorBoundary } from '@/shared/errors';
import { NotificationProvider } from '@/shared/ui/notification';

export function App() {
  const router = useMemo(() => createAppRouter(), []);

  return (
    <ErrorBoundary>
      {/*
        The notification provider wraps the router, not the other way round, so
        a notification raised from a route's own loader or a page's action has a
        provider above it. It renders its own viewport, so there is nothing else
        to mount.
      */}
      <NotificationProvider>
        <RouterProvider router={router} />
      </NotificationProvider>
    </ErrorBoundary>
  );
}
